module.exports = global["$"] = require("-!/Users/peterseifert/Projekte/EKF/node_modules/expose-loader/index.js?jQuery!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/jquery/dist/jquery.js-exposed
// module id = 330
// module chunks = 1